/**
 * ?fr=skill_deviation のように指定する文字列
 */
export const FINDY_REFERRER_TAGS = {
  // スキル偏差値
  SKILL_DEVIATION: 'skill_deviation',

  // スキル偏差値推移
  SKILL_TRANSITION: 'skill_transition',

  // 想定年収
  ANNUAL_SALARY: 'annual_salary',

  // 累計アクティビティ
  TOTAL_ACTIVITY: 'total_activity',

  // バッジ
  FINDY_TITLE_BADGE: 'findy_title_badge',

  // 発信力スコア
  INFLUENCE_SCORE: 'influence_score',

  // コントリビューション・オブ・ザ・イヤー2023
  CONTRIBUTION_OF_THE_YEAR_2023: 'twcp_coty2023',

  // コントリビューション・オブ・ザ・イヤー2024中間発表
  CONTRIBUTION_OF_THE_YEAR_2024: 'twcp_coty2024-mid',

  // エンジニアおみくじ2025
  OMIKUJI_2025: 'twcp_omikuji2025',

  // スキル偏差値v2.1
  SKILL_DEVIATION_V21: 'twcp_skill-deviation-v2.1',

  // スキル偏差値v3
  SKILL_DEVIATION_V3: 'twcp_skill-deviation-v3',

  // Findy Freelance導線
  FINDY_FREELANCE_REFERRAL: 'fc_referral',

  // 想定年収v2（キャンペーン終了後）
  ANNUAL_INCOME_V2_NEW: 'twshare_income-v2',

  // Findyレポート
  REPORT: (id: number): `twcp_report_${number}` => `twcp_report_${id}`,

  // エンジニアのお気持ち投票
  FINDY_ENGINEER_POLL: 'findy-engineer-poll',

  // エンジニアトレンドマガジン
  TREND_MAGAZINE: 'trend-magazine',

  // Findy ID連携
  FINDY_ID_PLATFORM: 'findy-id-platform',
} as const;

type ExcludeFunction<T> = Pick<
  T,
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [K in keyof T]: T[K] extends (...args: any[]) => any ? never : K;
  }[keyof T]
>;

type ExtractFunction<T> = Pick<
  T,
  {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [K in keyof T]: T[K] extends (...args: any[]) => any ? K : never;
  }[keyof T]
>;

export type FindyReferrerType =
  | ExcludeFunction<typeof FINDY_REFERRER_TAGS>[keyof ExcludeFunction<
      typeof FINDY_REFERRER_TAGS
    >]
  | ReturnType<
      ExtractFunction<typeof FINDY_REFERRER_TAGS>[keyof ExtractFunction<
        typeof FINDY_REFERRER_TAGS
      >]
    >;
